import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";
import loanTypesSteps from "./slices/steps/loanTypesSteps";
import personalDetails from "./slices/steps/personalDetails";
import employmentDetails from "./slices/steps/employmentDetails";
import incomeDetails from "./slices/steps/incomeDetails";
import assetsLiabilities from "./slices/steps/assetsLiabilities";
import jointApplication from "./slices/steps/jointApplication";
import jointpersonalDetails from "./slices/steps/jointpersonalDetails";
import jointemploymentDetails from "./slices/steps/jointemploymentDetails";
import jointAssetsLiabilities from "./slices/steps/jointAssetsLiabilities";
import jointIncomeDetails from "./slices/steps/jointIncomeDetails";

const persistConfig = {
  key: "root",
  version: 1,
  storage,
  whitelist: [
    "loanTypesSteps",
    "personalDetails",
    "employmentDetails",
    "incomeDetails",
    "assetsLiabilities",
    "jointpersonalDetails",
    "jointemploymentDetails",
    "jointIncomeDetails",
    "jointAssetsLiabilities",
  ],
};

const rootReducer = combineReducers({
  loanTypesSteps,
  personalDetails,
  employmentDetails,
  incomeDetails,
  assetsLiabilities,
  jointApplication,
  jointpersonalDetails,
  jointemploymentDetails,
  jointAssetsLiabilities,
  jointIncomeDetails,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});

export const persistor = persistStore(store);

// Type definitions for better TypeScript support
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
